import React from "react";

import Select from "antd/es/select";
import Tooltip from "antd/es/tooltip";
import { IntlShape } from "react-intl";

import FieldCategory from "@mapmycustomers/shared/enum/fieldModel/FieldCategory";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import IFieldModel, {
  CategorizedFields,
} from "@mapmycustomers/shared/types/fieldModel/IFieldModel";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { displayNameComparator } from "@app/util/comparator";
import { getFieldCategoryDisplayName } from "@app/util/ui";

export const getOptions = (
  fields: IField[],
  filterModel: Partial<FilterModel>,
  fieldModel: IFieldModel,
  keyPrefix = ""
) =>
  fields.map((field) => {
    const enabledOrMessage = field.isFilterEnabled
      ? field.isFilterEnabled(filterModel, fieldModel)
      : true;
    return (
      <Select.Option
        disabled={enabledOrMessage !== true}
        key={`${keyPrefix}${field.name}`}
        // label is not used when keyPrefix is used to avoid finding same field twice
        label={keyPrefix ? "" : field.displayName}
        value={field.name}
      >
        <Tooltip title={enabledOrMessage !== true ? enabledOrMessage : undefined}>
          {field.displayName}
        </Tooltip>
      </Select.Option>
    );
  });

const getFieldColumnOptions = (
  intl: IntlShape,
  categorizedFields: CategorizedFields,
  filterModel: Partial<FilterModel>,
  fieldModel: IFieldModel,
  showGroups: boolean = true
) => {
  if (showGroups) {
    return (Object.keys(categorizedFields) as FieldCategory[]).map((category) =>
      categorizedFields[category]!.length ? (
        <Select.OptGroup key={category} label={getFieldCategoryDisplayName(intl, category)}>
          {getOptions(categorizedFields[category]!, filterModel, fieldModel)}
        </Select.OptGroup>
      ) : null
    );
  } else {
    const fields = Object.values(categorizedFields).flat().sort(displayNameComparator);
    return getOptions(fields, filterModel, fieldModel);
  }
};

export default getFieldColumnOptions;
